import { useEnterpriseRatesByIdQuery } from '@mews-commander/core/entities';

interface RateNameProps {
    rateId: string;
}

export const RateName = ({ rateId }: RateNameProps) => {
    const { data: allFetchedRates } = useEnterpriseRatesByIdQuery();
    const foundRate = allFetchedRates?.[rateId];
    return foundRate?.name ? <span data-test-id="rateName">{foundRate.name}</span> : null;
};
